"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import styles from "./styles.module.scss"
import Typography from "@mui/material/Typography"
import PrimaryButton from "../shared/PrimaryButton"
import SecondaryButton from "../shared/SecondaryButton"
import Image from "next/image"
import { YELLOW_COLOR } from "../shared/constants"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid" // Grid version 2
import zestPic from "./images/zest-image.jpg"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"

function ZestLifeDefinition() {
  const [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ] = useRedirectToLeaderOnboarding()
  const renderLogo = () => {
    return (
      <div className={styles["header"]}>
        <Typography variant={"h1"}>ZestLife</Typography>
      </div>
    )
  }

  const renderPicture = () => {
    return (
      <div className={"flex justify-center items-center"}>
        <div
          className={`relative w-[160px] h-[160px] min-[600px]:w-[190px] min-[600px]:h-[190px]`}
        >
          <Image
            src={zestPic}
            fill
            // height={190}
            // width={190}
            alt={"lemon zest with grater"}
          />
        </div>
      </div>
    )
  }
  const renderBody = () => {
    return (
      <div className={styles["body"]}>
        <div className={styles["paragraph"]}>
          <b>Zest:</b> Little pieces of an outer layer that add enjoyment, energy,
          interest, enthusiasm, or flavor!
        </div>
        <div className={styles["paragraph"]}>
          <b>Life:</b> A series of stages and phases requiring something different,
          and often new.
        </div>
        <div className={styles["paragraph"]}>
          <b>Mental health:</b> A lifelong relationship between one’s outer and inner
          world, made up of micro building blocks and experiences that culminate and
          flux over time.
        </div>
        <div className={styles["paragraph"]}>
          <b>ZestLife:</b> A holistic resource for groups where people can find the
          kind of mental wellness zest they’re looking for when they need it.
        </div>
      </div>
    )
  }

  const renderButtons = () => {
    return (
      <div className={styles["buttons-container-outer"]}>
        <div className={styles["buttons-container"]}>
          <div className={`${styles["button-container"]} ${styles["button-left"]}`}>
            <PrimaryButton
              color={YELLOW_COLOR}
              text={"Join community"}
              href={getRouteForLeaderOnboarding()}
            />
          </div>
          <div className={`${styles["button-container"]} ${styles["button-right"]}`}>
            <SecondaryButton
              text={"Get monthly listings"}
              onClick={async () => {
                getMonthlyListingsClickHandler()
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  const renderBlueSection = () => {
    return (
      <div className={styles["blue-container"]}>
        <Typography variant={"h1"} component={"h3"}>
          Help people zest life.
        </Typography>
        {renderButtons()}
      </div>
    )
  }

  return (
    <div className={styles["container"]}>
      <Container disableGutters maxWidth={"lg"}>
        <Grid
          container
          spacing={2}
          columns={9}
          sx={{
            justifyContent: "center",
            margin: 0,
          }}
        >
          <Grid
            size={{
              xs: 7,
              md: 5,
            }}
            sx={{
              padding: 0,
            }}
          >
            <div className={styles["container-inner"]}>
              <div className={styles["container-inner-border"]}>
                {renderLogo()}
                {renderPicture()}
                {renderBody()}
              </div>
              {renderBlueSection()}
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}
export default ZestLifeDefinition
